import type { AtendenteDTO } from '@viniko/shared';
import type { ReactNode } from 'react';
import { NavLink, Navigate, Route, Routes } from 'react-router-dom';
import { Atendentes } from './Atendentes';
import { Atendimento } from './Atendimento';
import { CadastrosRecebidos } from './CadastrosRecebidos';
import { Etiquetas } from './Etiquetas';
import { Modelos } from './Modelos';
import { RoboFotos } from './RoboFotos';
import { MeuPerfil } from './MeuPerfil';
import { RespostasRapidas } from './RespostasRapidas';
import './configuracoes.css';

const FUTURAS = [['Integrações e log', 'Fases 2 a 6']] as const;

const SECOES_ADMIN: { caminho: string; rotulo: string; tela: ReactNode }[] = [
  { caminho: 'atendimento', rotulo: 'Atendimento', tela: <Atendimento /> },
  { caminho: 'respostas-rapidas', rotulo: 'Respostas rápidas', tela: <RespostasRapidas /> },
  { caminho: 'etiquetas', rotulo: 'Etiquetas', tela: <Etiquetas /> },
  { caminho: 'modelos', rotulo: 'Modelos de mensagem', tela: <Modelos /> },
  { caminho: 'robo-fotos', rotulo: 'Robô de fotos', tela: <RoboFotos /> },
  { caminho: 'cadastros', rotulo: 'Cadastros recebidos', tela: <CadastrosRecebidos /> },
];

export function Configuracoes({ eu }: { eu: AtendenteDTO }) {
  const admin = eu.papel === 'admin';
  return (
    <div className="config">
      <nav className="config-nav" aria-label="Configurações">
        <h1>Configurações</h1>
        <NavLink to="/configuracoes" end>
          Meu perfil
        </NavLink>
        {admin && (
          <>
            <NavLink to="/configuracoes/atendentes">Atendentes</NavLink>
            {SECOES_ADMIN.map((s) => (
              <NavLink key={s.caminho} to={`/configuracoes/${s.caminho}`}>
                {s.rotulo}
              </NavLink>
            ))}
          </>
        )}
        <div className="config-futuras">
          {FUTURAS.map(([nome, quando]) => (
            <span key={nome}>
              {nome} <small>{quando}</small>
            </span>
          ))}
        </div>
      </nav>
      <section className="config-corpo">
        <Routes>
          <Route index element={<MeuPerfil eu={eu} />} />
          <Route
            path="atendentes"
            element={admin ? <Atendentes eu={eu} /> : <Navigate to="/configuracoes" replace />}
          />
          {SECOES_ADMIN.map((s) => (
            <Route
              key={s.caminho}
              path={s.caminho}
              element={admin ? s.tela : <Navigate to="/configuracoes" replace />}
            />
          ))}
        </Routes>
      </section>
    </div>
  );
}
